/**
 * PersistContraSenhaDestinatarioRequest
 * @author Thacryba
 */
import {$, HttpIgnore, Model, ResponseFill} from 'simpli-web-sdk'
import ContraSenhaDestinatario from '@/model/resource/ContraSenhaDestinatario'

@HttpIgnore()
export default class PersistContraSenhaDestinatarioRequest extends Model {
  readonly $name: string = 'PersistContraSenhaDestinatarioRequest'

  @ResponseFill()
  countersigns: ContraSenhaDestinatario[] = []

  async persistContraSenhaDestinatario(spinner = 'persistContraSenhaDestinatario') {
    const fetch = async () => {
      return await this.POST('/user/contra-senha-destinatario', this)
    }

    return await $.await.run(fetch, spinner)
  }
}
